import axios from 'axios';

export function LoadApiData(apiUrl, fields, filter = null, sort = null, callback) {
	if (!filter) filter = '';
	filter += '&filter[site]=' + document.documentElement.lang;
	if (!sort) sort = '';

	axios.get(apiUrl + '?fields=' + fields + filter + "&sort=" + sort, {
				responseType: 'json'
			})
			.then((response) => {
				// Handle success
				if (typeof callback == 'function') callback(response.data);
			})
			.catch((error) => {
				console.log('Error while loading data form ' + apiUrl + ': ' + error.responseText);
			});
}
